import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SupplierDeductionsRoutingModule } from './supplier-deductions-routing.module';
import { PhoenixManageListPageLayoutsModule } from '@kehe/phoenix-layouts';
import { PhoenixMenuButtonModule } from '@kehe/phoenix-button';
import { PhoenixSearchModule } from '@kehe/phoenix-search';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SupplierDeductionsRoutingModule,
    PhoenixManageListPageLayoutsModule,
    PhoenixMenuButtonModule,
    PhoenixSearchModule,
  ],
})
export class SupplierDeductionsModule {}
